<template>
  <div class="supreme-header"
       :data-sensors-exposure-property-caseId="sensorsCaseId"
       data-sensors-exposure-event-name="Element_Exposure"
       :class="className"
       @click="toDetail"
       data-sensors-click
       :style="cardType==='supreme'? 'background:linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%)':`background-image:url(${backgroundImgUrl})`"
  >
    <img class="leading" :src="leadingIcon">
    <div class="text" :class="className">{{ title }}</div>
    <div v-if="cardType === 'supreme'" class="trailing">
      <div class="text">去领取</div>
      <img class="trailing" src="./images/icon_arrow_right_circle.png">
    </div>
  </div>
</template>

<script>
import supermeTopIcon from './images/icon_home_supreme_top.png'
import trailingArrowIcon from './images/icon_arrow_right_circle.png'

export default {
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    cardType () {
      if (this.isNotEmptyString(this.info.passCardInfo?.passCardTag)) {
        return 'pass'
      } else if (this.isNotEmptyString(this.info.upCardInfo?.upCardTag)) {
        return 'up'
      } else {
        return 'supreme'
      }
    },
    className () {
      if (this.isNotEmptyString(this.info.passCardInfo?.passCardTag) || this.isNotEmptyString(this.info.upCardInfo?.upCardTag)) {
        return 'general'
      } else {
        return 'supreme'
      }
    },
    leadingIcon () {
      if (this.isNotEmptyString(this.info.kingFloatInfo?.kingCardTitle)) {
        return supermeTopIcon
      }
    },
    title () {
      return this.info.passCardInfo?.title || this.info.upCardInfo?.title || this.info.kingFloatInfo?.kingCardTitle
    },
    actionTitle () {
      if (this.isNotEmptyString(this.info.kingFloatInfo?.kingCardTitle)) {
        return '去领取'
      }
      return null
    },
    trailingIcon () {
      if (this.isNotEmptyString(this.info.kingFloatInfo?.kingCardTitle)) {
        return trailingArrowIcon
      }
      return null
    },
    sensorsCaseId () {
      return this.cardType === 'pass'
        ? 'PASS_CARD'
        : this.cardType === 'up'
          ? 'UP_CARD' : 'SKC_M'
    },
    backgroundImgUrl () {
      if (this.cardType === 'pass') {
        return this.info.passCardInfo.backgroundImgUrl
      } else if (this.cardType === 'up') {
        return this.info.upCardInfo.backgroundImgUrl
      }
    }
  },
  methods: {
    toDetail () {
      if (this.cardType === 'supreme') {
        this.jumpToKingCardPage()
      } else if (this.cardType === 'up') {
        this.$emit('onUpCardTap')
      } else {
        this.$router.push('/middle/limit')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.supreme-header {
  width: 670px;
  height: 80px;
  background-size: 100% 100%;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 0 18px;
  &.general {
    justify-content: flex-start
  }
  .leading {
    height: 44px;
  }
  .text {
    height: 40px;
    font-size: 27px;
    font-weight: 400;
    line-height: 40px;
    font-family: PingFangSC-Regular, PingFang SC;
    &.supreme {
      width: 308px;
      color: #333333;
    }
    &.general {
      padding-left: 140px;
      color: #763E12;
    }
  }
  .trailing {
    width: 126px;
    height: 36px;
    background: #1C2032;
    border-radius: 18px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .text {
      width: 80px;
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFDEBA;
      line-height: 33px;
    }
    .trailing {
      width: 23px;
      height: 23px;
    }
  }
}
</style>